import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const MedicalOrderList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="medicalOrder"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default MedicalOrderList;
